import PageTemplate from '../containers/common/PageTemplate';

import Container from '../containers/mobile_product';

export default function MobileMain() {
  return (
    <>
      <PageTemplate type={true}>
        <Container />
      </PageTemplate>
    </>
  );
}
